import axiosInstance from './axios';
import { INFORMATION_REQUESTS } from './api_routes';

export function hasIrlProjectId() {
    const projectId = typeof localStorage === 'undefined' ? null : localStorage.getItem('project_id');
    return Boolean(projectId) && projectId !== 'null' && projectId !== 'undefined';
}

function readProjectId() {
    if (!hasIrlProjectId()) return null;
    return localStorage.getItem('project_id');
}

function missingProjectError() {
    const error = new Error('Select a project.');
    error.response = { status: 400, data: { detail: 'Select a project.' } };
    return error;
}

function projectPath(suffix) {
    const projectId = readProjectId();
    return `${INFORMATION_REQUESTS}${projectId}/${suffix}`;
}

async function request(method, suffix, data, config) {
    if (!readProjectId()) {
        return Promise.reject(missingProjectError());
    }
    const response = await axiosInstance({
        method,
        url: projectPath(suffix),
        data,
        ...config,
    });
    return response.data;
}

export function getIrlScreen() {
    return request('get', 'screen/');
}

export function createIrlRequest(body) {
    return request('post', 'screen/', body);
}

export function getIrlFolders(workstreamId) {
    const params = workstreamId ? `?workstream_id=${encodeURIComponent(workstreamId)}` : '';
    return request('get', `screen-folders/${params}`);
}

export function searchIrlRequests(query) {
    return request('get', `screen-search/?q=${encodeURIComponent(query || '')}`);
}

export function submitIrlResponse(pk, responseText) {
    return request('post', `${pk}/submit/`, { response: responseText });
}

export function saveIrlDraft(pk, responseText) {
    return request('post', `${pk}/save-draft/`, { response: responseText });
}

export function updateIrlFields(pk, body) {
    return request('post', `${pk}/update-fields/`, body || {});
}

export function bulkUpdateIrlFields(body) {
    return request('post', 'screen-bulk-update/', body || {});
}

export function bulkDeleteIrlRequests(body) {
    return request('post', 'screen-bulk-delete/', body || {});
}

export function bulkAddIrlRequests(body) {
    return request('post', 'bulk_add/', body || {});
}

export function uploadIrlEvidence(pk, files) {
    const body = new FormData();
    Array.from(files || []).forEach(file => body.append('files', file));
    return request('post', `${pk}/upload-evidence/`, body, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
}

export function openIrlEvidence(openUrl) {
    return axiosInstance.get(openUrl).then(response => response.data);
}

export function transitionIrl(pk, action, body) {
    return request('post', `${pk}/${action}/`, body || {});
}

export function postIrlComment(pk, comment, parent, mentions) {
    return request('post', `${pk}/comment/`, { comment, parent, mentions });
}

export function editIrlComment(pk, commentId, comment, mentions) {
    return request('post', `${pk}/comment/${commentId}/edit/`, { comment, mentions: mentions || [] });
}

export function deleteIrlComment(pk, commentId) {
    return request('post', `${pk}/comment/${commentId}/delete/`);
}

export function resolveIrlComment(pk, commentId) {
    return request('post', `${pk}/comment/${commentId}/resolve/`);
}

export function reopenIrlComment(pk, commentId) {
    return request('post', `${pk}/comment/${commentId}/reopen/`);
}

export function markIrlDiscussionRead(pk) {
    return request('post', `${pk}/mark-read/`);
}

export function getIrlMentionCandidates(pk) {
    return request('get', `${pk}/mention-candidates/`);
}

export function startIrlAiReview(body) {
    return request('post', 'ai-review/', body);
}

export function getIrlAiReview(runId) {
    return request('get', `ai-review/${runId}/`);
}

export function acceptIrlProposal(runId, proposalId, body) {
    return request('post', `ai-review/${runId}/accept/`, { proposal_id: proposalId, body: body || '' });
}

export function dismissIrlProposal(runId, proposalId) {
    return request('post', `ai-review/${runId}/dismiss/`, { proposal_id: proposalId });
}

export function createIrlFollowUp(runId, proposalId, question) {
    return request('post', `ai-review/${runId}/follow-up/`, { proposal_id: proposalId, question: question || '' });
}
